import { GridListLabel } from '@app/components/base/content-structure/GridListLabel';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { memo } from 'react';
import { MessageDescriptor } from 'react-intl';
import {
  FRAGMENT_LIST_CONTAINER_SX,
  FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE,
  FRAGMENTS_GRID_SPACING,
} from '../fragment-card/constants';
import { FragmentCard } from '../fragment-card/FragmentCardFactory';
import { useFragmentGridContext } from './FragmentGridContext';

/**
 * Renders a single date section: optional sticky label + fragment cards.
 * List view: single column, full width (max lg). Grid view: multi-column grid by viewMode.
 */
export const FragmentsListDateSection = memo(function FragmentsGridDateSection({
  titleMessage,
  showTitle,
  fragments,
}: {
  titleMessage: MessageDescriptor;
  showTitle: boolean;
  fragments: FragmentListItemDto[];
}) {
  const { viewMode } = useFragmentGridContext();
  const isList = viewMode === 'list';

  if (!fragments.length) return null;

  return (
    <Box sx={{ mb: 6 }}>
      {showTitle && <GridListLabel sticky message={titleMessage} />}
      {isList ? (
        <Stack spacing={2} sx={FRAGMENT_LIST_CONTAINER_SX}>
          {fragments.map((fragment) => (
            <FragmentCard key={fragment.id} fragment={fragment} />
          ))}
        </Stack>
      ) : (
        <Grid container spacing={FRAGMENTS_GRID_SPACING} columns={60}>
          {fragments.map((fragment) => (
            <Grid size={FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE[viewMode]} key={fragment.id}>
              <FragmentCard fragment={fragment} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
});
